import { Pipe } from '@angular/core';
import { CalendarEventTitleFormatter } from './calendar-event-title-formatter.provider';
var CalendarEventTitlePipe = /** @class */ (function () {
    function CalendarEventTitlePipe(calendarEventTitle) {
        this.calendarEventTitle = calendarEventTitle;
    }
    CalendarEventTitlePipe.prototype.transform = function (title, titleType, event) {
        var newArray = [];
        var tooltipArray = [];
        if(event){
         newArray = [(event.Attendees[0].FirstName ? event.Attendees[0].FirstName.charAt(0).toUpperCase() + event.Attendees[0].FirstName.slice(1) + ' ' : '') + (event.Attendees[0].LastName ? event.Attendees[0].LastName.charAt(0).toUpperCase() +  event.Attendees[0].LastName.slice(1) : '')];
            if(event.Attendees.length > 1){
                newArray.push(' & ' + (event.Attendees.length - 1) + ' more')
            }

            for (let i = 0; i < event.Attendees.length; i++) {
                const element = event.Attendees[i];
                tooltipArray.push((element.FirstName ? element.FirstName.charAt(0).toUpperCase() + element.FirstName.slice(1) + ' ' : '') + (element.LastName ? element.LastName.charAt(0).toUpperCase() + element.LastName.slice(1) : ''));
            }
        }
        event['newTitle'] = newArray.join(' ');
        if(event.Attendees.length > 1){
            event['titleToolTip']= tooltipArray.join(", ");        
        }else{
            event['titleToolTip']= tooltipArray.join();        
        }
        return this.calendarEventTitle[titleType](event);
    };
    CalendarEventTitlePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'calendarEventTitle'
                },] },
    ];
    /** @nocollapse */
    CalendarEventTitlePipe.ctorParameters = function () { return [
        { type: CalendarEventTitleFormatter, },
    ]; };
    return CalendarEventTitlePipe;
}());
export { CalendarEventTitlePipe };
//# sourceMappingURL=calendar-event-title.pipe.js.map 


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/angular-calendar/modules/common/calendar-event-title.pipe.js
// module id = ./src/app/shared/angular-calendar/modules/common/calendar-event-title.pipe.js
// module chunks = main